import type { CheckinFeedItem } from 'server/dbx/checkin-feedback';
import { CHECKIN_REACTIONS } from 'shared/checkin-feedback';
import { checkinItemTitle } from './checkin-item-labels';

/**
 * A student's standups and weekly summaries, with coach reactions and
 * replies, as plain text for the coach's own AI evaluation thread. Oldest
 * first, so the story runs forwards. Answers carry the prompt text they were
 * written against, so a reworded prompt never changes old standups.
 */
export function checkinFeedToText(name: string, items: CheckinFeedItem[], startDate?: string) {
  const entries = items
    .slice()
    .sort((a, b) => (a.date === b.date ? a.kind.localeCompare(b.kind) : a.date < b.date ? -1 : 1))
    .map((item) => {
      const heading = checkinItemTitle(item, startDate);
      const content =
        item.kind === 'summary'
          ? item.body.trim()
          : item.answers.map((a) => `${a.prompt}\n${a.answer}`).join('\n\n');
      const reactions = CHECKIN_REACTIONS.map((r) => {
        const who = item.feedback.reactions.filter((x) => x.reaction === r.key);
        return who.length ? `${r.emoji} ${who.map((x) => x.coachName).join(', ')}` : '';
      }).filter(Boolean);
      const replies = item.feedback.replies.map((r) => `Reply from ${r.authorName}:\n${r.body}`);
      const feedback = [reactions.length ? `Reactions: ${reactions.join('  ')}` : '', ...replies]
        .filter(Boolean)
        .join('\n\n');
      return [heading, content, feedback].filter(Boolean).join('\n\n');
    });

  return [`Standups and weekly summaries — ${name}`, ...entries].join('\n\n---\n\n');
}
